$(function () {
  if (!customElements.get('factory-product-testing')) {
    customElements.define(
      'factory-product-testing',
      class factoryProductTesting extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          gsapLazy(() => {
            if (window.innerWidth > 960) {
              this.init(); // 执行初始化代码
            } else {
              this.mobileInit();
            }
          });
        }
        init() {
          gsap.registerPlugin(ScrollTrigger);

          const root = $(this); // 保存当前实例对应的 DOM 元素
          const $main = root.find('.main');
          const $wrapper = root.find('.steps-wrapper');
          const $images = root.find('.images-wrapper');
          const $progress = root.find('.progress-wrapper');
          const length = $wrapper.children().length; // 获取子元素数量
          const computedGap = getComputedStyle($wrapper[0]);
          const wrapperGap = parseFloat(computedGap.gap);
          let innerHeight = $($wrapper.children()[0]).innerHeight();
          const scrollOffset = innerHeight + wrapperGap; // 每个子元素对应的位移量

          const opacity_1 = 0.5;
          const opacity_2 = 0.2;

          const timeline = gsap.timeline({
            scrollTrigger: {
              pin: true,
              pinSpacing: true,
              scrub: true,
              trigger: $main[0], // 使用 jQuery 获取的元素需要使用原生 DOM 节点
              start: '0 0', // 根据需要调整 start 位置
              end: $main.height() * length + 2000, // 根据子元素数量动态设置 end
              onEnter: () => {
                $($main.children()[0]).addClass('mask_conceal');
              },
              onLeaveBack: () => {
                $($main.children()[0]).removeClass('mask_conceal');
              },
            },
          });

          // 第一个的初始值处理
          gsap.to($wrapper.children()[0], {
            opacity: 1,
          });
          gsap.to($wrapper.children()[1], {
            opacity: opacity_1,
          });
          gsap.to($wrapper.children()[2], {
            opacity: opacity_2,
          });
          gsap.to($wrapper.find('.desc')[0], {
            opacity: 1,
          });
          gsap.to($images.find('.image-item')[0], {
            y: 0,
          });

          // 动态遍历子元素并生成动画
          $wrapper.children().each((index, child) => {
            // 第一个和最后一个不发生偏移
            if (index !== 0 && index !== length - 1) {
              timeline.to(
                $wrapper[0],
                {
                  y: `-${scrollOffset * (index - 1)}px`, // 根据索引动态设置 y 偏移
                },
                index // 动画时间轴位置，按索引动态排列
              );
            }

            // 透明度变化动画
            if (index === length - 1) {
              // 最后一个透明度的渐变
              timeline.to(
                $wrapper.children()[length - 1],
                {
                  opacity: 1,
                },
                index // 动画时间轴位置，按索引动态排列
              );
              timeline.to(
                $wrapper.children()[length - 2],
                {
                  opacity: opacity_1,
                },
                index // 动画时间轴位置，按索引动态排列
              );
              timeline.to(
                $wrapper.children()[length - 3],
                {
                  opacity: opacity_2,
                },
                index // 动画时间轴位置，按索引动态排列
              );
            } else {
              timeline.to(
                $wrapper.children()[index - 1],
                {
                  opacity: opacity_1,
                },
                index // 动画时间轴位置，按索引动态排列
              );
              timeline.to(
                $wrapper.children()[index],
                {
                  opacity: 1,
                },
                index // 动画时间轴位置，按索引动态排列
              );
              timeline.to(
                $wrapper.children()[index + 1],
                {
                  opacity: opacity_1,
                },
                index // 动画时间轴位置，按索引动态排列
              );
            }

            // 描述透明度变化
            timeline.to(
              $wrapper.find('.desc')[index - 1],
              {
                opacity: 0,
              },
              index
            );
            timeline.to(
              $wrapper.find('.desc')[index],
              {
                opacity: 1,
              },
              index
            );
            timeline.to(
              $wrapper.find('.desc')[index + 1],
              {
                opacity: 0,
              },
              index
            );

            // 图片切换动画
            if (index !== 0) {
              timeline.fromTo(
                $images.find('.image-item')[index],
                { y: 2000, duration: 0.8 },
                { y: 0, duration: 0.8 },
                index
              );
              timeline.to(
                $images.find('.image-item')[index - 1],
                { opacity: 0, scale: 0.8, duration: 0.8 },
                index + 0.2
              );
            }
            // 进度条动画
            if (index === 0) {
              timeline.to(
                $progress.find('.progress-circle')[0],
                {
                  y: 0,
                  onUpdate: () => {
                    $progress.removeClass('progress_bar_start');
                    $progress.removeClass('progress_bar_end');
                    $progress.removeClass('progress_bar_middle');
                    $progress.addClass('progress_bar_start');
                  },
                },
                index
              );
            } else if (index === length - 1) {
              timeline.to(
                $progress.find('.progress-circle')[0],
                {
                  y: scrollOffset * 2,
                  onUpdate: () => {
                    $progress.removeClass('progress_bar_start');
                    $progress.removeClass('progress_bar_end');
                    $progress.removeClass('progress_bar_middle');
                    $progress.addClass('progress_bar_end');
                  },
                },
                index
              );
            } else {
              timeline.to(
                $progress.find('.progress-circle')[0],
                {
                  y: scrollOffset,
                  onUpdate: () => {
                    $progress.removeClass('progress_bar_start');
                    $progress.removeClass('progress_bar_end');
                    $progress.removeClass('progress_bar_middle');
                    $progress.addClass('progress_bar_middle');
                  },
                },
                index
              );
            }
          });
        }
        mobileInit() {
          gsap.registerPlugin(ScrollTrigger);
          const root = $(this); // 保存当前实例对应的 DOM 元素
          const $main = root.find('.mobile_main');
          const $wrapper = root.find('.mobile-steps-wrapper');
          const $images = root.find('.mobile-images-wrapper');
          const length = $images.children().length; // 获取子元素数量
          const computedGap = getComputedStyle($wrapper[0]);
          const wrapperGap = parseFloat(computedGap.gap);
          let innerWidth = $($wrapper.children()[0]).innerWidth();
          const scrollOffset = innerWidth + wrapperGap;

          // 第一个的初始值处理
          gsap.to($images.children()[0], {
            opacity: 1,
          });
          if (window.innerWidth <= 576) {
            gsap.to($wrapper[0], {
              x: `${innerWidth / 2}px`,
            });
          } else {
            gsap.to($wrapper[0], {
              x: `${innerWidth}px`,
            });
          }

          setTimeout(() => {
            const timeline = gsap.timeline({
              scrollTrigger: {
                pin: true,
                pinSpacing: true,
                scrub: true,
                trigger: $main[0], // 使用 jQuery 获取的元素需要使用原生 DOM 节点
                start: '0 0', // 根据需要调整 start 位置
                end: $main.height() * length + 1000, // 根据子元素数量动态设置 end
                onEnter: () => {
                  $($main.children()[0]).addClass('mask_conceal');
                },
                onLeaveBack: () => {
                  $($main.children()[0]).removeClass('mask_conceal');
                },
              },
            });
            $images.children().each((index) => {
              // 图片切换动画
              if (index !== 0) {
                timeline.to($images.find('.mobile-image-item')[index], { opacity: 1 }, index);
              }
              // 步骤切换动画;
              if (index === 0) {
                timeline.to(
                  $wrapper[0],
                  {
                    onComplete: () => {}, // 根据索引动态设置 y 偏移
                  },
                  index // 动画时间轴位置，按索引动态排列
                );
                timeline.to(
                  $wrapper.children()[index],
                  {
                    opacity: 1,
                  },
                  index // 动画时间轴位置，按索引动态排列
                );
              } else if (index === 1) {
                if (window.innerWidth <= 576) {
                  timeline.to(
                    $wrapper[0],
                    {
                      x: `-${innerWidth / 2 + wrapperGap}px`,
                      onComplete: () => {}, // 根据索引动态设置 y 偏移
                    },
                    index // 动画时间轴位置，按索引动态排列
                  );
                } else {
                  timeline.to(
                    $wrapper[0],
                    {
                      x: `-${wrapperGap}px`,
                      onComplete: () => {}, // 根据索引动态设置 y 偏移
                    },
                    index // 动画时间轴位置，按索引动态排列
                  );
                }

                timeline.to(
                  $wrapper.children()[index],
                  {
                    opacity: 1,
                  },
                  index // 动画时间轴位置，按索引动态排列
                );
                timeline.to(
                  $wrapper.children()[index - 1],
                  {
                    opacity: 0.5,
                  },
                  index // 动画时间轴位置，按索引动态排列
                );
              } else {
                if (window.innerWidth <= 576) {
                  timeline.to(
                    $wrapper[0],
                    {
                      x: `-${scrollOffset * (index - 1) + wrapperGap + innerWidth / 2}px`,
                      onComplete: () => {}, // 根据索引动态设置 y 偏移
                    },
                    index // 动画时间轴位置，按索引动态排列
                  );
                } else {
                  timeline.to(
                    $wrapper[0],
                    {
                      x: `-${scrollOffset * (index - 1) + wrapperGap}px`,
                      onComplete: () => {}, // 根据索引动态设置 y 偏移
                    },
                    index // 动画时间轴位置，按索引动态排列
                  );
                }

                timeline.to(
                  $wrapper.children()[index],
                  {
                    opacity: 1,
                  },
                  index // 动画时间轴位置，按索引动态排列
                );
                timeline.to(
                  $wrapper.children()[index - 1],
                  {
                    opacity: 0.5,
                  },
                  index // 动画时间轴位置，按索引动态排列
                );
              }
            });
            // 空一格
            timeline.to(
              $wrapper[0],
              {
                onComplete: () => {}, // 根据索引动态设置 y 偏移
              },
              length // 动画时间轴位置，按索引动态排列
            );
          }, 1000);
        }
      }
    );
  }
});
